import {
  SupplierDeclarationField,
  type ResolvedEspdCriterionDto,
  type ResolvedEspdRequirementDto,
  type ResolvedEspdRequirementGroupDto,
} from "../../../../../autogen/bff-api";

const allRequirements = (group: ResolvedEspdRequirementGroupDto): ResolvedEspdRequirementDto[] => [
  ...group.requirements,
  ...group.subGroups.flatMap(allRequirements),
];

export const declarationFieldIdOf = (
  criterion: ResolvedEspdCriterionDto,
  field: SupplierDeclarationField
): string | undefined =>
  criterion.requirementGroups
    .flatMap(allRequirements)
    .find((r) => r.supplierDeclarationField === field)?.id;

export const groupRoleRequirementIdOf = (criterion: ResolvedEspdCriterionDto): string | undefined =>
  declarationFieldIdOf(criterion, SupplierDeclarationField.GroupRole);

export const groupNameRequirementIdOf = (criterion: ResolvedEspdCriterionDto): string | undefined =>
  declarationFieldIdOf(criterion, SupplierDeclarationField.GroupName);
